import React from 'react'
import { Trans } from '@lingui/macro'
import { useDispatch, useSelector } from 'react-redux'
import { ButtonLink } from 'components/UI/ButtonLink/ButtonLink'
import { getColor } from 'components/utils'
import { Alert } from 'components/UI/Alert/Alert'

import { IdZreportsState } from 'model/dashboardZreports/dZreportReducer'
import { InputCheckbox } from 'components/UI/InputCheckbox/InputCheckbox';

import {
    dZReportsCheckedAllItemAC,
    dZReportsCheckedItemAC, dZReportsSetDetailItemAC
} from 'model/dashboardZreports/dZreportsActionCreators';

import { typeDataZReportsBulkActions } from '../index';

import { DotsVerticalIcon } from '@heroicons/react/outline';
import { numberCurrencyFormat } from 'constants/convertToLocalCurrency';


// Type
export type typeTableHeader = {
    variant?: string
    bulkOperations: typeDataZReportsBulkActions
}

// Header data component
export const TableHeader: React.FC<typeTableHeader> = ({ variant, bulkOperations }) => {
    const color = getColor(variant)

    const dispatch = useDispatch()

    const tableData = useSelector((state: { dZReports: IdZreportsState }) => state.dZReports.data)
    const groupActions = tableData.find(item => item.checked)

    const checkedAll = () => {
        dispatch(dZReportsCheckedAllItemAC(true))
    }

    const unCheckedAll = () => {
        dispatch(dZReportsCheckedAllItemAC(false))
    }
    return (
        <>
            { !groupActions
                ? <>
                    <th scope="col"
                        className="px-4 py-3  text-xs font-medium uppercase tracking-wider text-center">
                        <InputCheckbox id="selectAll" checked={ false } onChange={ () => checkedAll() }/>
                    </th>
                    <th scope="col"
                        className="px-4 py-3  text-left text-xs font-medium uppercase tracking-wider">
                        <Trans>Fiscal card number</Trans>
                    </th>
                    <th scope="col"
                        className="px-4 py-3  text-center text-xs font-medium uppercase tracking-wider ">
                        <Trans>Date</Trans>
                    </th>
                    <th scope="col"
                        className="px-4 py-3 text-center text-xs font-medium uppercase tracking-wider ">
                        <Trans>Z-report number</Trans>
                    </th>
                    <th scope="col"
                        className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider ">
                        <Trans>sum total</Trans>
                    </th>
                    <th scope="col"
                        className="px-4 py-3  text-left text-xs font-medium uppercase tracking-wider">
                        <Trans>Amount of VAT</Trans>
                    </th>
                    <th scope="col"
                        className="px-4 py-3  text-left text-xs font-medium uppercase tracking-wider ">
                        <Trans>shop name</Trans>
                    </th>
                    <th scope="col"
                        className="px-4 py-3  text-left text-xs font-medium uppercase tracking-wider ">
                        <Trans>terminal SN</Trans>
                    </th>
                    <th scope="col"
                        className="w-1">

                    </th>

                </>
                : <>
                    <th scope="col"
                        className=" px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider  cursor-pointer">
                        <div className="flex justify-center" onClick={ () => unCheckedAll() }>
                            <div
                                className={ `flex flex-col justify-center items-center h-4 w-4 text-white focus:ring-white border border-gray-100 rounded bg-${ color }-600` }>
                                <div className="h-0.5 w-2 my-1 bg-white rounded"/>
                            </div>
                        </div>
                    </th>
                    <th colSpan={ 8 } className="py-3 text-sm">
                        <div className="flex divide-x divide-gray-300">
                            { bulkOperations.map((item, index) => <ButtonLink key={ index } dark={ true }
                                                                              buttonClassName="px-3 font-medium text-gray-700"
                                                                              type="button" label={ item.title }
                                                                              onClick={ () => item.action(false) }/>) }

                        </div>
                    </th>
                </> }
        </>
    )
}


// Type
export type typeAction = {
    title: JSX.Element,
    disableSwitcher?: boolean,
    action: (id: string) => void,
}

export type typeTableBody = {
    variant?: string
    rowsActions: typeAction[]
    setOpenPopupDetails: React.Dispatch<React.SetStateAction<boolean>>
}


// Body data component
export const TableBody: React.FC<typeTableBody> = ({ variant, rowsActions, setOpenPopupDetails }) => {

    const color = getColor(variant)

    const dispatch = useDispatch()

    const tableData = useSelector((state: { dZReports: IdZreportsState }) => state.dZReports.data)


    let component

    const onChangeSelectItemHandler = (id: string) => {
        dispatch(dZReportsCheckedItemAC(id))
    }

    const onCellClickHandler = (e: React.MouseEvent<HTMLTableDataCellElement, MouseEvent>, id: string) => {
        dispatch(dZReportsSetDetailItemAC(id))
        setOpenPopupDetails(true)
    }

    if (tableData.length) {
        component = tableData.map((item, index) => {
            return (
                <tr key={ item.id }
                    className={ `${ index % 2 === 0 ? 'bg-white' : 'bg-gray-50' } hover:bg-${ color }-50` }>
                    <td className="px-4 py-3  whitespace-nowrap text-sm text-gray-500">
                        <div className="flex justify-center">
                            <InputCheckbox
                                id={ 'select-' + item.id }
                                checked={ item.checked }
                                onChange={ () => onChangeSelectItemHandler(item.id) }
                            />
                        </div>
                    </td>
                    <td className="px-4 py-3 px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900 cursor-pointer"
                        onClick={ (e) => onCellClickHandler(e, item.id) }>{ item.fiscalCardId }</td>
                    <td className="px-4 py-3 whitespace-nowrap text-xs  text-gray-500 cursor-pointer"
                        onClick={ (e) => onCellClickHandler(e, item.id) }>
                        <div className="flex flex-col justify-center divide-y">
                            <p><span className="text-gray-400"><Trans>opened: </Trans></span><span
                                className="text-gray-500 font-medium"> { item.openDate.replace('T', ' ')
                                .substring(0, 19) }</span></p>
                            <p><span className="text-gray-400"><Trans>closed: </Trans></span><span
                                className="text-gray-500 font-medium">  { item.closeDate.replace('T', ' ')
                                .substring(0, 19) }</span></p>
                        </div>
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900 cursor-pointer text-center"
                        onClick={ (e) => onCellClickHandler(e, item.id) }>{ item.zreportNumber? item.zreportNumber : '-' }</td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900 cursor-pointer"
                        onClick={ (e) => onCellClickHandler(e, item.id) }>{ numberCurrencyFormat(+( +item.salesWithCash + +item.salesWithCards ).toFixed(2)) }</td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm  text-gray-500 cursor-pointer"
                        onClick={ (e) => onCellClickHandler(e, item.id) }>{ numberCurrencyFormat(+item.vatAmount) }</td>
                    <td className="px-4 py-3  whitespace-nowrap text-sm  text-gray-500 cursor-pointer"
                        onClick={ (e) => onCellClickHandler(e, item.id) }>{ item.store.name }</td>
                    <td className="px-4 py-3  whitespace-nowrap text-sm f text-gray-500 cursor-pointer"
                        onClick={ (e) => onCellClickHandler(e, item.id) }>{ item.terminalSerianNumber }</td>
                    <td className=" whitespace-nowrap text-sm text-gray-500">
                        <div className="relative flex justify-center">
                            <div
                                className="h-10 w-10 cursor-pointer flex flex-col justify-center items-center row-action-block">
                                <DotsVerticalIcon className="h-5 w-5 text-gray-900"/>
                                <div
                                    className="absolute bg-white rounded-md shadow-md right-0 px-4 py-3 row-action-list">
                                    <div className="flex gap-x-4">
                                        { rowsActions.map((actionItem, ActionIndex) => {
                                                              return (
                                                                  <ButtonLink key={ ActionIndex } type={ 'button' }
                                                                              label={ actionItem.title }
                                                                              onClick={ () => actionItem.action(item.id) }/>
                                                              )
                                                          }
                                        ) }
                                    </div>
                                </div>
                            </div>
                        </div>

                    </td>
                </tr>
            )
        })
    } else {
        component = <tr>
            <td className="p-2" colSpan={ 8 }>
                <Alert className="w-full" type={ 'info' }
                       title={ <Trans>The Z-reports list is empty. Check filters list.</Trans> }/>
            </td>
        </tr>
    }

    return (
        <>
            { component }
        </>
    )
}
